// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"c97963d6","239":"6b2993b9","455":"1df9d44a","977":"48b03396"}[chunkId] + ".chunk.js";
};